<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage" id="_idContainer003">
<p class="pl-title"><a id="_idTextAnchor000"></a>Her Cowboy Reunion</p>
<p class="pl-center"><em class="italic">USA TODAY</em> Bestselling Author </p>
<p class="pl-author">Ruth Logan Herne</p>
<p class="pl-author">&amp;</p>
<p class="pl-title"><a id="_idTextAnchor001"></a>Hill Country Reunion</p>
<p class="pl-author">Myra Johnson</p>
<p class="pl-logo"><img alt="logo" height="70" src="image/LI_2020.png"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_Page.vue?075a8f5e